import React from 'react';
import { OfficeSelect } from '../offices/OfficeSelect';

export const StaffOfficeList = ({ staff, offices, onSet }) => (
  <div className="bg-white border rounded-xl p-4 space-y-2" data-testid="admin-staff-office-list">
    <h4 className="font-semibold">Logins and office access</h4>
    {!staff.length && <p className="text-sm text-slate-500">No logins yet.</p>}
    {staff.map((s) => (
      <div key={s.id} className="flex flex-wrap items-center justify-between gap-2 py-2 border-b last:border-0" data-testid={`admin-staff-row-${s.id}`}>
        <div>
          <p className="text-sm font-medium">{s.firstName} {s.lastName} <span className="text-xs text-slate-500">· {s.role === 'practice_admin' ? 'Practice admin' : (s.accessLevel || 'front_desk').replace('_', ' ')}{s.isActive === false ? ' · off' : ''}</span></p>
          <p className="text-xs text-slate-500">{s.email}</p>
        </div>
        {s.role === 'practice_staff'
          ? <OfficeSelect offices={offices} value={s.officeId} allLabel="All offices" onChange={(v) => onSet(s.id, v)} testId={`admin-staff-office-${s.id}`} />
          : <span className="text-xs text-slate-500">Sees all offices</span>}
      </div>
    ))}
  </div>
);
